import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import ImageBackground from '../common/imageBackground';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';

class AlphaListing extends Component {
  /**************
   * Properties *
   **************/
  state = {
    listingImage: require('./images/AZListing.png'),
    navigationBar: {
      back: true,
      backRoute: this.getBackRoute(),
      mainMenu: true,
      navigate: true
    }
  };

  getBackRoute() {
    let backRoute = '/main_menu';
    if (this.props.match.params.categoryName) {
      backRoute = `/movies/categories/${this.props.match.params.categoryName}`;
      if (this.props.match.params.movieName) {
        backRoute += `/${this.props.match.params.movieName}`;
      }
    }
    return backRoute;
  }

  getScreenRoute = () => {
    let screenRoute = '/movies/screen';
    if (this.props.match.params.categoryName) {
      screenRoute += `/${this.props.match.params.categoryName}`;
      if (this.props.match.params.movieName) {
        screenRoute += `/${this.props.match.params.movieName}`;
      }
    }
    return screenRoute;
  };

  goToScreen = () => this.props.history.push({pathname: this.getScreenRoute(), state: { baseUrl: '/movies/listing' }});

  handleOnKeyUp = event => {
    switch (event.key) {
      case 'Enter':
        if (this.props.context === APPLICATION_CONTEXTS.SERVICES) {
          this.goToScreen();
        }
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div>
        <ImageBackground id="background" />
        <ImageText id="text" src={this.state.listingImage} />
        <button className="listing-movie" onMouseUp={this.goToScreen} />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedAlphaListing = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(AlphaListing);

export default withRouter(ConnectedAlphaListing);
